import React from 'react'
import PropTypes from 'prop-types'

// Info circle from the design system (Figma component "info", rounded).
const PATH_D = 'M10 14.1667C10.2361 14.1667 10.434 14.0868 10.5938 13.9271C10.7535 13.7674 10.8333 13.5694 '
  + '10.8333 13.3333V10C10.8333 9.76389 10.7535 9.56597 10.5938 9.40625C10.434 9.24653 10.2361 '
  + '9.16667 10 9.16667C9.76389 9.16667 9.56597 9.24653 9.40625 9.40625C9.24653 9.56597 9.16667 '
  + '9.76389 9.16667 10V13.3333C9.16667 13.5694 9.24653 13.7674 9.40625 13.9271C9.56597 14.0868 '
  + '9.76389 14.1667 10 14.1667ZM10 7.5C10.2361 7.5 10.434 7.42014 10.5938 7.26042C10.7535 7.1007 '
  + '10.8333 6.90278 10.8333 6.66667C10.8333 6.43056 10.7535 6.23264 10.5938 6.07292C10.434 '
  + '5.9132 10.2361 5.83333 10 5.83333C9.76389 5.83333 9.56597 5.9132 9.40625 6.07292C9.24653 '
  + '6.23264 9.16667 6.43056 9.16667 6.66667C9.16667 6.90278 9.24653 7.1007 9.40625 '
  + '7.26042C9.56597 7.42014 9.76389 7.5 10 7.5ZM10 18.3333C8.84722 18.3333 7.76389 18.1146 6.75 '
  + '17.6771C5.73611 17.2396 4.85417 16.6458 4.10417 15.8958C3.35417 15.1458 2.76042 14.2639 '
  + '2.32292 13.25C1.88542 12.2361 1.66667 11.1528 1.66667 10C1.66667 8.84722 1.88542 7.76389 '
  + '2.32292 6.75C2.76042 5.73611 3.35417 4.85417 4.10417 4.10417C4.85417 3.35417 5.73611 2.76042 '
  + '6.75 2.32292C7.76389 1.88542 8.84722 1.66667 10 1.66667C11.1528 1.66667 12.2361 1.88542 '
  + '13.25 2.32292C14.2639 2.76042 15.1458 3.35417 15.8958 4.10417C16.6458 4.85417 17.2396 '
  + '5.73611 17.6771 6.75C18.1146 7.76389 18.3333 8.84722 18.3333 10C18.3333 11.1528 18.1146 '
  + '12.2361 17.6771 13.25C17.2396 14.2639 16.6458 15.1458 15.8958 15.8958C15.1458 16.6458 '
  + '14.2639 17.2396 13.25 17.6771C12.2361 18.1146 11.1528 18.3333 10 18.3333ZM10 16.6667C11.8611 '
  + '16.6667 13.4375 16.0208 14.7292 14.7292C16.0208 13.4375 16.6667 11.8611 16.6667 10C16.6667 '
  + '8.13889 16.0208 6.5625 14.7292 5.27083C13.4375 3.97917 11.8611 3.33333 10 3.33333C8.13889 '
  + '3.33333 6.5625 3.97917 5.27083 5.27083C3.97917 6.5625 3.33333 8.13889 3.33333 10C3.33333 '
  + '11.8611 3.97917 13.4375 5.27083 14.7292C6.5625 16.0208 8.13889 16.6667 10 16.6667Z'

const InfoCircleOutlineIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d={PATH_D} fill="currentColor" />
  </svg>
)

InfoCircleOutlineIcon.propTypes = {
  className: PropTypes.string
}

InfoCircleOutlineIcon.defaultProps = {
  className: 'tw:h-3.5 tw:w-3.5'
}

export default InfoCircleOutlineIcon
